const WINTER = [
  "wind",
  "snow",
  "road-ice",
  "low-temperature",
  "thunderstorm",
  "rain",
  "fog",
] as const;
const SPRING = ["wind", "snow", "road-ice", "thunderstorm", "rain", "fog"] as const;
const SUMMER = ["wind", "high-temperature", "thunderstorm", "rain", "fog"] as const;

const ICON_NAMES = {
  wind: "wind",
  snow: "snowflake",
  "road-ice": "ice",
  // Legacy combined code; older warning sets may still send it.
  "snow-ice": "snow-ice",
  "low-temperature": "low-temperature",
  "high-temperature": "high-temperature",
  thunderstorm: "thunderstorm",
  rain: "rain",
  fog: "fog",
  waterspouts: "waterspouts",
} as const;

/** Icon URLs shared by CSS masks, image badges and Deck.gl thumbnails. */
export const riskPicturePhenomenonIconUrl = (phenomenon: string): string =>
  `/icons/phenomena_${Object.hasOwn(ICON_NAMES, phenomenon) ? ICON_NAMES[phenomenon as keyof typeof ICON_NAMES] : "warning"}.svg`;

/** Translated names where available; never leak a missing i18n key to the UI. */
export const riskPicturePhenomenonName = (
  phenomenon: string,
  t: (key: string, options: { defaultValue: string }) => string,
): string => {
  const label = phenomenon.replace(/[-_]+/g, " ").trim();
  const fallback = label ? label[0].toUpperCase() + label.slice(1) : "Unknown phenomenon";
  return t(`ewt.phenomena.${phenomenon}`, { defaultValue: fallback });
};

/**
 * Phenomenon rows for an Amsterdam calendar date (`YYYY-MM-DD`).
 *
 * Windows are half-open on `MM-DD`: 15 Oct starts winter, 1 Apr starts the
 * shoulder without koude, 1 May starts summer. The string compare needs the
 * zero-padded date from `formatInTimeZone`, not an API timestamp.
 */
export const riskPicturePhenomena = (date: string): readonly string[] => {
  const monthDay = date.slice(5);
  if (monthDay >= "10-15" || monthDay < "04-01") return WINTER;
  if (monthDay < "05-01") return SPRING;
  return SUMMER;
};
